import React from "react";
import { Flex, PictureFrame } from "../Box";
import { HeaderStyle } from "./styles";
import avatar from "../../assets/tiny.jpg";

const Menu = () => {
  return (
    <HeaderStyle>
      <Flex className="container" width="55%">
        <Flex flexWrap="nowrap" className="profile">
          <div className="profile-details">
            <h1>Chidera Ugwuanyi</h1>
            <p>Mobile Application developer</p>
            <div className="social-handle">
              {/* <a href="/">M</a>
              <a href="/">G</a>
              <a href="/">T</a>
              <a href="/">L</a> */}
            </div>
          </div>

          <div className="profile-image">
            <PictureFrame height="200px" width="200px">
              <img src={avatar} alt="" />
            </PictureFrame>
          </div>
        </Flex>

        <div className="about">
          <p>
            Chidera Ugwuanyi is a Mobile Application developer; software trainer and lifelong learner. <br/>
            With 2+ years experience, Chidera is a powerful
            force in the workplace , a team player with great communication skills and uses his positive attitude and tireless
            energy to encourage others to work hard and succeed. 
          </p>
          <p>
            I work with Javascript, ES6, React(for web), React Native(for Mobile App Development), Apollo, GraphQL and Styled components.
          </p>
          <p>Whe not coding, Chidera enjoys
            traveling and reading novels. </p>
        </div>
      </Flex>
    </HeaderStyle>
  );
};
export default Menu;
